export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/ACRTiffToJPEGWorker.98a6c0c2.worker.js");
}
